import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    AccessVisibility,
    SystemEntity,
} from '@wdx/clmi/clmi-swagger-gen';
import { Observable } from 'rxjs';
import { ConfigService } from '../../services/config.service';

@Injectable()
export class VisibilityService {
    constructor(
        private http: HttpClient,
        private config: ConfigService,
    ) {}

    getVisibilityForId(
        entityType: SystemEntity,
        entityId: string,
    ): Observable<AccessVisibility[]> {
        return this.http.get<AccessVisibility[]>(
            `${this.config.getConfiguration().API_BASE}/${entityType.toLowerCase()}/${entityId}/visibility`,
        );
    }
}
